var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(-6161.798 -2923)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 26,
    height: 26,
    transform: "translate(6161.798 2923)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M6179.7,2932.13l-5.575,8.539a12.884,12.884,0,0,1-2.088,2.363l-1.281,1.084a1.863,1.863,0,0,1-.812.438,1,1,0,0,1-.944-.269,1.428,1.428,0,0,1-.242-1.392l.4-1.723a10.8,10.8,0,0,1,1.251-2.925l5.575-8.54Zm.812-1.243.032-.048a2.227,2.227,0,0,0-.639-3.078,2.279,2.279,0,0,0-3.074.654l-.031.047Z",
    fill: "#636b91"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.caf7c1660c02fe48801fddb248306101.svg";
export { ForwardRef as ReactComponent };